/** Agreement statuses that can be revised before the customer signs. */
const EDITABLE_AGREEMENT_STATUSES = ['draft', 'awaiting_accept'];

const isEditableAgreementStatus = (status) =>
  EDITABLE_AGREEMENT_STATUSES.includes(String(status || '').toLowerCase());

/**
 * Map a contract row from GET /my/agreements into NewAgreement form state.
 * @param {object} contract
 */
const contractToFormState = (contract) => {
  if (!contract) return null;

  const lineItems = (contract.lineItems || []).map((row) => ({
    kind: row.kind || 'subscription',
    billingFrequency: row.billingFrequency || 'annual',
    unitAmount: row.unitAmount != null && row.unitAmount !== '' ? row.unitAmount : '',
    quantity: row.quantity != null ? row.quantity : 1,
    description: row.description || '',
    stripeProductId: row.stripeProductId || '',
    stripePriceId: row.stripePriceId || '',
    currency: row.currency || '',
    discount: row.discount || null,
    bandingQuantity: row.bandingQuantity != null ? row.bandingQuantity : '',
  }));

  const term = contract.term || {};
  const indexationPolicy = contract.indexationPolicy || { kind: 'none' };

  return {
    type: contract.type || 'Direct',
    customerOrganisationName: contract.customerOrganisationName || '',
    customerFirstName: contract.customerFirstName || '',
    customerLastName: contract.customerLastName || '',
    customerEmail: contract.customerEmail || '',
    customerRegisteredCountry: contract.customerRegisteredCountry || '',
    customerBillingCountry: contract.customerBillingCountry || '',
    billingCurrency: contract.billingCurrency || '£',
    whiteLabelId: contract.whiteLabelId != null ? String(contract.whiteLabelId) : '0',
    consultantId: contract.consultantId != null ? String(contract.consultantId) : 'NONE',
    payMode: contract.payMode || 'invoice',
    lineItems: lineItems.length ? lineItems : undefined,
    term: {
      type: term.type || 'committed',
      lengthMonths: term.lengthMonths != null ? term.lengthMonths : 36,
      startDate: term.startDate || '',
      noticePeriodDays: term.noticePeriodDays != null ? term.noticePeriodDays : 60,
    },
    indexationPolicy: {
      kind: indexationPolicy.kind || 'none',
      floorPercent: indexationPolicy.floorPercent != null ? indexationPolicy.floorPercent : 5,
      cpiSource: indexationPolicy.cpiSource || 'UK_CPIH',
      noticeDays: indexationPolicy.noticeDays != null ? indexationPolicy.noticeDays : 30,
    },
    linkedExistingOrganisation: !!contract.linkedExistingOrganisation,
    linkedOrganisationId: contract.organisationId || contract.organisation || '',
    replaceExistingSubscription: !!contract.replaceExistingSubscription,
    endClientDefaultPlanType:
      contract.endClientDefaultPlanType === 'client_subscription' ? 'client_subscription' : 'per_report',
    perReportFeeVal:
      contract.perReportFeeVal != null && contract.perReportFeeVal !== ''
        ? String(contract.perReportFeeVal)
        : '',
  };
};

export { EDITABLE_AGREEMENT_STATUSES, isEditableAgreementStatus, contractToFormState };
